import React, { useEffect } from 'react';
import { twMerge } from 'utilities/src/twMerge';

import { AnimatePresence, motion } from 'framer-motion';
import { type MobileMenuProps } from './_props';

import MobileMenuItem from './MobileMenuItem';
import useHeader from '../header/hooks/useHeader';

function MobileMenu({ menuItems }: MobileMenuProps) {
  const { isMobileMenuOpen } = useHeader();

  useEffect(() => {
    document.body.style.overflowY = isMobileMenuOpen ? 'hidden' : 'auto';
    return () => {
      document.body.style.overflowY = 'auto';
    };
  }, [isMobileMenuOpen]);

  return (
    <AnimatePresence>
      {isMobileMenuOpen && (
        <motion.section
          key="mobile-menu"
          initial={{ width: 0, right: 0 }}
          animate={{ width: '100%', left: 0, right: 'auto' }}
          exit={{ width: 0, right: 0, left: '100%' }}
          transition={{ type: 'tween', duration: 0.2 }}
          className={twMerge(
            'h-[100vh] overflow-y-auto overscroll-contain',
            'bg-site-neutrals-0 text-site-neutrals-900 fixed top-20 z-50 block max-h-screen w-full shadow-2xl',
          )}
        >
          <nav className="flex flex-col items-start justify-center gap-6 pb-24 [&>button]:ml-8 [&>ul]:w-full">
            <ul>
              {menuItems.map((menuItem) => (
                <MobileMenuItem key={menuItem.id} menuItem={menuItem} />
              ))}
            </ul>
          </nav>
        </motion.section>
      )}
    </AnimatePresence>
  );
}

export default MobileMenu;
